<h1>Algoritmo Rilettura</h1>
<form action="">
  <div class="ui-grid ui-grid-responsive ui-fluid card" >
    <div class="ui-grid-row">
      <div class="ui-grid-col-4">
        <label for="from">Parte da </label>
        <input type="number" name="from" [(ngModel)]="from">
      </div>
      <div class="ui-grid-col-4">
        <label for="to">Fino a </label>
        <input type="number" name="to" [(ngModel)]="to">
      </div>
      <div class="ui-grid-col-4">
        <label for="minimumInterval" style="margin-right: 5px;">Intervallo Minimo </label>
        <input type="number" name="minimumInterval" [(ngModel)]="minimumInterval" style="margin-right: 10px;">
      </div>
    </div>
    <div class="ui-grid-row">
      <div class="ui-grid-col-4">
        <h2>Max. Storni Qta</h2>
      </div>
      <div class="ui-grid-col-8">
        <label for="maxStarlings">Max. Storni Val.</label>
        <input type="number" name="maxStarlings" [(ngModel)]="maxStarlings" step=".01">
      </div>
    </div>
    <div class="ui-grid-row">
        <div class="ui-grid-col-4">
          <h2>Bonus - Malus</h2>
        </div>
        <div class="ui-grid-col-8">
            <div class="ui-grid ui-grid-responsive ui-fluid bonus-malus" >
              <div class="ui-grid-row">
                <div class="ui-grid-col-4">
                  <label for="bonus1from">Da </label>
                  <input type="number" name="bonus1from" [(ngModel)]="bonus1from" step=".01">
                </div>
                <div class="ui-grid-col-4">
                  <label for="bonus1to">A </label>
                  <input type="number" name="bonus1to" [(ngModel)]="bonus1to" step=".01">
                </div>
                <div class="ui-grid-col-4">
                  <label for="bonus1step">Step </label>
                  <input type="number" name="bonus1step" [(ngModel)]="bonus1step">
                </div>
              </div>
              <div class="ui-grid-row">
                <div class="ui-grid-col-4">
                  <label for="bonus2from">Da </label>
                  <input type="number" name="bonus2from" [(ngModel)]="bonus2from" step=".01">
                </div>
                <div class="ui-grid-col-4">
                  <label for="bonus2to">A </label>
                  <input type="number" name="bonus2to" [(ngModel)]="bonus2to" step=".01">
                </div>
                <div class="ui-grid-col-4">
                  <label for="bonus2step">Step </label>
                  <input type="number" name="bonus2step" [(ngModel)]="bonus2step">
                </div>
              </div>
              <div class="ui-grid-row">
                <div class="ui-grid-col-4">
                  <label for="bonus3from">Da </label>
                  <input type="number" name="bonus3from" [(ngModel)]="bonus3from" step=".01">
                </div>
                <div class="ui-grid-col-4">
                  <label for="bonus3to">A </label>
                  <input type="number" name="bonus3to" [(ngModel)]="bonus3to" step=".01">
                </div>
                <div class="ui-grid-col-4">
                  <label for="bonus3step">Step </label>
                  <input type="number" name="bonus3step" [(ngModel)]="bonus3step" step=".01">
                </div>
              </div>
            </div>
        </div>
      </div>
  </div>
</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/algoritmo-rilettura/algoritmo-rilettura.component.html